module.exports = __webpack_public_path__ + "img/ghtwh.986988e2.png";